"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __importStar = (this && this.__importStar) || (function () {
    var ownKeys = function(o) {
        ownKeys = Object.getOwnPropertyNames || function (o) {
            var ar = [];
            for (var k in o) if (Object.prototype.hasOwnProperty.call(o, k)) ar[ar.length] = k;
            return ar;
        };
        return ownKeys(o);
    };
    return function (mod) {
        if (mod && mod.__esModule) return mod;
        var result = {};
        if (mod != null) for (var k = ownKeys(mod), i = 0; i < k.length; i++) if (k[i] !== "default") __createBinding(result, mod, k[i]);
        __setModuleDefault(result, mod);
        return result;
    };
})();
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
var __param = (this && this.__param) || function (paramIndex, decorator) {
    return function (target, key) { decorator(target, key, paramIndex); }
};
var _a, _b;
Object.defineProperty(exports, "__esModule", { value: true });
exports.StyleForm = void 0;
const T = __importStar(require("@microsoft/fast-element"));
const fast_element_1 = require("@microsoft/fast-element");
require("./template.html");
const client_1 = require("@rws-framework/client");
const component_1 = require("@front/components/form-parts/form/component");
const component_2 = require("@front/components/site-menu/component");
const backendImport_1 = require("@front/backendImport");
const component_3 = require("@front/layouts/default-layout/component");
const PopupService_1 = __importStar(require("@front/services/PopupService"));
//@ts-ignore                
let rwsTemplate = T.html `<div class="container-fluid">
  <div class="style-form-page">
    <div class="row">
      <div class="col-lg-8 col-12 pb-lg-5">
        <div class="mb-2">
          <h1>${x => x.styleId ? 'style.form.title.edit'.t() : 'style.form.title.add'.t()}</h1>
          <div class="text-zero top-right-button-container">
            <button @click="${(x, c) => x.cancelEdit()}" type="button"
              class="top-right-button mr-1 btn btn-primary btn-lg">${'style.form.back'.t()}</button>
          </div>
        </div>
        <div class="card card-body mb-5">
          <the-form :onSubmit="${(x, c) => x.sendForm.bind(x)}">
            <div class="form-row">
              <div class="form-group col-md-12">
                <part-input required="true" class="form-part" label="${'style.form.name.label'.t()}"
                  :value="${x => x.form.name}" name="name" placeholder="${'style.form.name.placeholder'.t()}"
                  required="true"></part-input>
              </div>
              <div class="form-group col-md-12">
                <part-textarea class="form-part" label="${'style.form.description.label'.t()}"
                  :value="${x => x.form.description}" name="description" placeholder="${'style.form.description.placeholder'.t()}"
                  rows="3"></part-textarea>
              </div>
            </div>
            <div class="form-row">
              <div class="form-group col-md-12">
                <part-textarea required="true" class="form-part" label="${'style.form.prompt.label'.t()}"
                  :value="${x => x.form.prompt}" name="prompt" placeholder="${'style.form.prompt.placeholder'.t()}"
                  rows="6" required="true"></part-textarea>
              </div>
            </div>
            ${(0, fast_element_1.when)(x => x.isUserSuperAdmin, (0, fast_element_1.html) `
            <div class="form-row">
              <div class="form-group col-md-6">
                <part-checkbox class="form-part" label="${'style.form.common.label'.t()}"
                  :value="${x => x.form.common}" name="common"
                  description="${'style.form.common.description'.t()}"></part-checkbox>
              </div>
              <div class="form-group col-md-6">
                <part-checkbox class="form-part" label="${'style.form.active.label'.t()}"
                  :value="${x => x.form.active}" name="active"></part-checkbox>
              </div>
            </div>
            `)}
            ${(0, fast_element_1.when)(x => !x.isUserSuperAdmin && x.isUserParentOrAdmin, (0, fast_element_1.html) `
            <div class="form-row">
              <div class="form-group col-md-6">
                <part-checkbox class="form-part" label="${'style.form.active.label'.t()}"
                  :value="${x => x.form.active}" name="active"></part-checkbox>
              </div>
            </div>
            `)}
            <hr>
            <div class="form-row">
              <div class="col-12 text-right">
                <button type="button" @click="${(x, c) => x.cancelEdit()}"
                  class="btn btn-secondary mr-2">${'common.cancel'.t()}</button>
                <button @click="${(x, c) => x.sendSubmit(x, c)}" type="submit" class="btn btn-primary" ?disabled="${x => x.loading}">
                  ${x => x.loading ? 'general.saving'.t() : (x.styleId ? 'common.update'.t() : 'common.create'.t())}
                </button>
              </div>
            </div>
          </the-form>
        </div>
      </div>
    </div>
  </div>
  ${(0, fast_element_1.when)(x => x.loading, (0, fast_element_1.html) `<app-loader></app-loader>`)}
</div>`;
require("./styles/layout.scss");
const styles = T.css `.style-form-page .top-right-button-container {
  position: absolute;
  top: 0;
  right: 0;
}
.style-form-page .form-group {
  margin-bottom: 1.5rem;
}
.style-form-page .card {
  border: 1px solid #dee2e6;
  border-radius: 0.375rem;
  box-shadow: 0 0.125rem 0.25rem rgba(0, 0, 0, 0.075);
}
.style-form-page part-textarea textarea {
  min-height: 80px;
  resize: vertical;
}`;
const shadowOptions = { "mode": "open" };
let StyleForm = class StyleForm extends client_1.RWSViewComponent {
    constructor(popupService) {
        super();
        this.popupService = popupService;
        this.loading = false;
        this.styleId = null;
        this.sendSubmit = component_1.FormComponent.sendSubmitEvent;
    }
    get isUserSuperAdmin() {
        var _a;
        return ((_a = component_3.DefaultLayout.USER) === null || _a === void 0 ? void 0 : _a.role) === backendImport_1.UserRoles.SUPER_ADMIN;
    }
    get isUserParentOrAdmin() {
        var _a, _b, _c;
        return ((_a = component_3.DefaultLayout.USER) === null || _a === void 0 ? void 0 : _a.role) === backendImport_1.UserRoles.SUPER_ADMIN || ((_b = component_3.DefaultLayout.USER) === null || _b === void 0 ? void 0 : _b.role) === backendImport_1.UserRoles.PARENT_USER || ((_c = component_3.DefaultLayout.USER) === null || _c === void 0 ? void 0 : _c.role) === backendImport_1.UserRoles.ENTERPRISE;
    }
    async connectedCallback() {
        this.resetForm();
        super.connectedCallback();
        this.styleId = this.routeParams.id;
        if (this.styleId) {
            await this.loadStyle();
        }
        component_1.FormComponent.listenForValuesChange.bind(this)('form');
    }
    resetForm() {
        this.form = {
            name: '',
            description: '',
            prompt: '',
            common: false,
            active: true
        };
    }
    async loadStyle() {
        var _a;
        try {
            this.loading = true;
            const response = await this.apiService.back.get('style.get', {
                routeParams: { id: this.styleId }
            });
            if ((response === null || response === void 0 ? void 0 : response.success) && response.data) {
                this.form = {
                    name: response.data.name || '',
                    description: response.data.description || '',
                    prompt: response.data.prompt || '',
                    common: response.data.common || false,
                    active: (_a = response.data.active) !== null && _a !== void 0 ? _a : true
                };
            }
            else {
                this.notifyService.notify((response === null || response === void 0 ? void 0 : response.error) || 'style.failedToLoad'.t(), 'error');
                component_2.SiteMenu.goto.bind(this)('/settings/style/list');
            }
        }
        catch (error) {
            console.error('Error loading style:', error);
            this.notifyService.notify('style.failedToLoad'.t(), 'error');
            component_2.SiteMenu.goto.bind(this)('/settings/style/list');
        }
        finally {
            this.loading = false;
        }
    }
    async sendForm(event) {
        event.preventDefault();
        try {
            this.loading = true;
            let response;
            if (this.styleId) {
                response = await this.apiService.back.put('style.update', this.form, {
                    routeParams: { id: this.styleId }
                });
            }
            else {
                response = await this.apiService.back.post('style.create', this.form);
            }
            if (!response.success) {
                console.error(response.error);
                this.notifyService.notify(response.error || `${'style.failedTo'.t()} ${this.styleId ? 'style.update'.t() : 'style.create'.t()}`, 'error');
            }
            else {
                this.notifyService.notify(`${'style.style'.t()} ${this.styleId ? 'style.updated'.t() : 'style.created'.t()} ${'general.successfully'.t()}`, 'info');
                this.$emit('style-saved', { style: response.data });
                if (!this.styleId) {
                    // Reset form for add mode
                    this.resetForm();
                    for (const formPart of this.$('.form-part')) {
                        formPart.reset();
                    }
                }
                component_2.SiteMenu.goto.bind(this)('/settings/style/list');
            }
        }
        catch (e) {
            console.error(e);
            this.notifyService.notify(`${'style.failedTo'.t()} ${this.styleId ? 'style.update'.t() : 'style.create'.t()}`, 'error');
        }
        finally {
            this.loading = false;
        }
    }
    cancelEdit() {
        component_2.SiteMenu.goto.bind(this)('/settings/style/list');
    }
};
exports.StyleForm = StyleForm;
__decorate([
    client_1.observable,
    __metadata("design:type", Boolean)
], StyleForm.prototype, "loading", void 0);
__decorate([
    client_1.observable,
    __metadata("design:type", String)
], StyleForm.prototype, "styleId", void 0);
__decorate([
    client_1.observable,
    __metadata("design:type", typeof (_b = typeof backendImport_1.IStylePayload !== "undefined" && backendImport_1.IStylePayload) === "function" ? _b : Object)
], StyleForm.prototype, "form", void 0);
exports.StyleForm = StyleForm = __decorate([
    (0, client_1.RWSView)('style-form', null, { template: rwsTemplate, styles, options: { shadowOptions } }),
    __param(0, (0, client_1.RWSInject)(PopupService_1.default)),
    __metadata("design:paramtypes", [typeof (_a = typeof PopupService_1.PopupServiceInstance !== "undefined" && PopupService_1.PopupServiceInstance) === "function" ? _a : Object])
], StyleForm);
StyleForm.defineComponent();
